import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountListComponent } from './account/account-list/account-list.component';
import { JournelListComponent } from './journel/journel-list/journel-list.component';
import { LedgerListComponent } from './ledger/ledger-list/ledger-list.component';
import { CashbookListComponent } from './cashbook/cashbook-list/cashbook-list.component';

import { FinanceReportComponent } from './finance-report/finance-report.component';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';
import { ManageTransactionComponent } from './transaction/manage-transaction/manage-transaction.component';
import { TransactionsComponent } from './transaction/transactions/transactions.component';
import { ProfitLossComponent } from './profit&Loss/profit-loss.component';
import { LedgerReportComponent } from './ledger-report/ledger-report.component';
import { ManageVoucherComponent } from './voucher/manage-voucher/manage-voucher.component';
import { VoucherListComponent } from './voucher/voucher-list/voucher-list.component';
import { BalanceSheetComponent } from './balance-sheet/balance-sheet.component';

const routes: Routes = [
  {
    path: 'finance-report',
    component: FinanceReportComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'finance-report',
      modules: ['FINANCE REPORT']
    },
  },
  {
    path: 'account-list',
    canActivate: [ModuleGuard],
    component: AccountListComponent,
    data: {
      title: 'account-list',
      modules: ['ACCOUNT']
    },
  },
  {
    path: 'journal-list',
    canActivate: [ModuleGuard],
    component: JournelListComponent,
    data: {
      title: 'journal-list',
      modules: ['JOURNAL']
    },
  },
  {
    path: 'ledger-list',
    canActivate: [ModuleGuard],
    component: LedgerListComponent,
    data: {
      title: 'ledger-list',
      modules: ['GENERAL LEDGER']
    },
  },
  {
    path: 'cashbook-list',
    canActivate: [ModuleGuard],
    component: CashbookListComponent,
    data: {
      title: 'cashbook-list',
      modules: ['CASH BOOK']
    },
  },
  {
    path: 'transactions',
    component: TransactionsComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'transactions',
      modules: ['TRANSACTIONS']
    },
  },
  {
    path: 'profit-loss-report',
    canActivate: [ModuleGuard],
    component: ProfitLossComponent,
    data: {
      title: 'profit-loss-report',
      modules: ['PROFIT AND LOSS REPORT']
    }
  }
  , {
    path: 'ledger-report',
    component: LedgerReportComponent,
    // canActivate: [ModuleGuard],
    // data: {
    //   title: 'ledger-report',
    //   modules: ['LEDGER REPORT']
    // },
  },
  {
    path: 'voucher-list',
    canActivate: [ModuleGuard],
    component: VoucherListComponent,
    data: {
      title: 'voucher-list',
      modules: ['VOUCHER']
    },
  },
  {
    path: 'balancesheet-report',
    component: BalanceSheetComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'balance sheet report',
      modules: ['BALANCE SHEET REPORT']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinaceRoutingModule { }
